import React, { Suspense } from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import { routes } from "./routes/routeConfig";
import LoadingFallback from "./components/ui/LoadingFallback";

const AppRoutes = () => useRoutes(routes);

function App() {
  return (
    <Router>
      <Suspense fallback={<LoadingFallback />}>
        <AppRoutes />
      </Suspense>
    </Router>
  );
}

export default App;
